import { render, staticRenderFns } from "./sweetStakeTC.vue?vue&type=template&id=512c1d21&scoped=true&"
import script from "./sweetStakeTC.vue?vue&type=script&lang=js&"
export * from "./sweetStakeTC.vue?vue&type=script&lang=js&"
import style0 from "./sweetStakeTC.vue?vue&type=style&index=0&id=512c1d21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c1d21",
  null
  
)

export default component.exports